
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/evcharging/marketplace",
      function () {
        return require("private-next-pages/evcharging/marketplace/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/evcharging/marketplace"])
      });
    }
  